module.exports = __webpack_public_path__ + "static/media/1_7.4335eba0.png";